//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import TransitionShuffle from '../../global/transitions/Shuffle.vue';
import AppTag from './Tag.vue';
export default {
  name: "AppTags",
  props: ["tags", "removeTag", "clearAllTags"],
  components: {
    TransitionShuffle,
    AppTag
  },
  data() {
    return {};
  },
  computed: {
		...mapGetters([
			"siteName",
			"filters",
			"resultView",
		]),
		appliedFilterGroups() {
			let tagIds = this.tags.map(tag => tag.id);
			return this.filters.filter(group => group.filters.some(filter => tagIds.includes(filter.id)) ||
				group.filters.some(filter => filter.filters?.some(f => tagIds.includes(f.id))));
		},
		tagsByFilterGroup() {
			return this.appliedFilterGroups.map(group => {
				return {
					name: group.name,
					tags: this.tags.filter(tag => group.filters.some(f => f.id == tag.id) ||
							group.filters.some(filter => filter.filters?.some(f => f.id == tag.id)))
				}
			});
		},
	},
  methods: {},
  created() { },
  mounted() { },
};
